import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'

const getHighlights = (withParts: boolean) => async(
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const params = {
        userId:  userData.smsAuth.userId,
        withParts,

    }
    const config = {
        headers: {
            Authorization: `${anchor} ${localStorage.getItem('accessToken')}`
        }
    }
    dispatch({ type: storeDispatchTypes.setSalesLoader, value: { field: 'highlights', value: true } })
    try {
        const { data: { status, data } } = await apiInstance.post('/sales/highlights/getHighlights', params, config)
        if(status === 'ok') {
            dispatch({
                type: storeDispatchTypes.setHighlights,
                value: {
                    highlights: data
                },
            })
        }
    } catch (e) {
        console.error('get highlights failed', e)
    }
    dispatch({ type: storeDispatchTypes.setSalesLoader, value: { field: 'highlights', value: false } })

}


export default getHighlights
